import taxesEdit from '@/views/taxes/edit'
import taxesList from '@/views/taxes/list'

export default [
  {
    path: '/impostos',
    name: 'taxesList',
    component: taxesList,
    meta: {
      layout: 'sidebar',
      type: 'list',
      base: 'taxes',
      heading: 'menu.taxes',
      auth: true,
      roles: [
        {
          create:  ['super-admin'],
          edit: ['super-admin'],
          remove: ['super-admin']
        }
      ]
    }
  },
  {
    path: '/impostos/novo',
    name: 'taxesCreate',
    component: taxesEdit,
    meta: {
      layout: 'sidebar',
      base: 'taxes',
      heading: 'menu.taxes',
      auth: true,
      roles: ['super-admin']
    }
  },
  {
    path: '/impostos/:id/editar',
    name: 'taxesUpdate',
    component: taxesEdit,
    meta: {
      layout: 'sidebar',
      base: 'taxes',
      heading: 'menu.taxes',
      auth: true,
      roles: ['super-admin']
    }
  }
]
